import { useEffect } from 'react';
import { UseFormSetError, UseFormClearErrors } from 'react-hook-form';

export const useDuplicateBarcodeValidation = ({
  packagings,
  setError,
  clearErrors,
  t,
}: {
  packagings: { barcode?: string }[];
  setError: UseFormSetError<any>;
  clearErrors: UseFormClearErrors<any>;
  t: any;
}) => {
  useEffect(() => {
    if (!packagings) return;

    const seen = new Map<string, number[]>();

    packagings.forEach((p, idx) => {
      if (!p?.barcode) return;
      const list = seen.get(p.barcode) || [];
      list.push(idx);
      seen.set(p.barcode, list);
    });

    packagings.forEach((_, idx) => {
      clearErrors(`productPackagings.${idx}.barcode`);
    });

    let duplicateFound = false;

    Array.from(seen.entries()).forEach(([, positions]) => {
      if (positions.length > 1) {
        duplicateFound = true;
        positions.forEach(idx => {
          setError(`productPackagings.${idx}.barcode`, {
            type: 'duplicate',
            message: t('errors.duplicate_barcode'),
          });
        });
      }
    });

    if (duplicateFound) {
      setError('productPackagingsDuplicate', {
        type: 'duplicate',
        message: t('errors.duplicate_barcode'),
      });
    } else {
      clearErrors('productPackagingsDuplicate');
    }
  }, [packagings, setError, clearErrors, t]);
};
